(() => {
  const allowedFinishes = [
    'xof-jeol',
    'xof-p7ci',
    'xof-l0p2',
    'xof-s42x',
    'xof-vu9e',
    'xof-ygc0'
  ];

  const requestedFinish = new URLSearchParams(window.location.search).get('finish');

  if (!requestedFinish || !allowedFinishes.includes(requestedFinish)) return;

  const applyFilter = () => {
    const tab = document.querySelector(`li[data-val="${requestedFinish}"]`);

    if (tab) {
      tab.click();
      window.setTimeout(() => {
        tab.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      }, 100);
      return true;
    }

    const option = document.querySelector(`select option[value="${requestedFinish}"]`);

    if (option && option.parentElement) {
      option.parentElement.value = requestedFinish;
      option.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
      window.setTimeout(() => {
        option.parentElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
      return true;
    }

    return false;
  };

  if (applyFilter()) return;

  const observer = new MutationObserver(() => {
    if (applyFilter()) observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 6000);
})();
